import { Modal, Button } from "antd";
import "../../../assets/css/phonePage.css";

export default function NoticeModal({ show, handleModalCancel, handleModalConfirm, cancel }) {
    return (
        <Modal
            centered
            width={400}
            title="Important Notice"
            open={show}
            className="noticeModal"
            onCancel={cancel}
            footer={[
                <Button key="back" danger ghost className="noticeModalButton" onClick={handleModalCancel}>
                    cancel
                </Button>,
                <Button key="submit" type="primary" className="noticeModalButton" onClick={handleModalConfirm}>
                    confirm
                </Button>,
            ]}
        >
            Altering the SID might impact actions configured earlier. Nevertheless ,I remain interested in moving
            forward with the override.
        </Modal>
    );
}
